import { getBoardBackground } from "../../services/api/trelloApi";
import { hexToAdjustedHex } from "../../utils/modalTopColorConverter";
import CardRelationshipsIcon from "../../assets/images/card-relationships-icon-main.svg";
import getCardRelationshipsData from "../../services/api/getCardRelationshipsData";
import { postEmptyCardRelationshipsData } from "../../services/api/postEmptyCardRelationshipsData";
import { updateCustomerDataOnEnable } from "../../services/api/customerAndSubscriptionHelpers";
import { checkAuthorizationAndSubscription } from "../../utils/checkAuthorizationAndSubscription";
import { isFeatureEnabled } from "../../utils/featureFlag"; // Remove after successful launch
import { trackSentryEvent, initializeSentry } from "../../analytics/sentry";

// Initialize Sentry for global error logging and analytics
initializeSentry();

window.TrelloPowerUp.initialize(
  {
    "board-buttons": function (t, opts) {
      return [
        {
          icon: CardRelationshipsIcon,
          text: process.env.POWERUP_NAME,
          condition: "edit",
          callback: openModal,
        },
      ];
    },
    "card-back-section": function (t, opts) {
      if (!powerupPermission(t)) {
        return;
      }

      return {
        title: "Relationships",
        icon: CardRelationshipsIcon,
        content: {
          type: "iframe",
          url: t.signUrl("./card-back.html"),
          height: 40,
        },
        action: {
          text: "View all",
          callback: openModal,
        },
      };
    },
    "show-settings": function (t, opts) {
      return t.popup({
        title: "Card Relationships Settings",
        url: "./settings.html",
      });
    },
    "on-enable": async function (t, opts) {
      // THE BELOW IS COMMENTED OUT WHILE MIGRATEOLDDATATONETLIFY HANDLES postEmptyCardRelationshipsData
      // const existingCardRelationships = await getCardRelationshipsData(t);

      // if (!existingCardRelationships) {
      //   await postEmptyCardRelationshipsData(t);
      // }

      // Remove after successful launch (start)
      if (await isFeatureEnabled({ t })) {
        // If the subscription feature is not enabled, let the user through
        await updateCustomerDataOnEnable(t); // KEEP THIS LINE AFTER SUCCESSFUL LAUNCH
      }
      // Remove after successful launch (end)

      // Record analytics
      try {
        const org = await t.organization("id");
        trackSentryEvent("board_enabled", { organization_id: org.id });
      } catch (e) {
        // Log but do not block
        console.error("Failed to record enable event", e);
      }

      return t.modal({
        title: "",
        accentColor: "#1064E3",
        url: "./authorize.html",
        height: 593,
        args: { trigger: "onEnable" },
      });
    },
    "on-disable": async function (t, opts) {
      // Record analytics
      try {
        const org = await t.organization("id");
        trackSentryEvent("board_disabled", { organization_id: org.id });
      } catch (e) {
        // Log but do not block
        console.error("Failed to record disable event", e);
      }
      const organization = await t.organization("id");
      return t.modal({
        title: "Card Relationships",
        accentColor: "#1064E3",
        url: "./on-disable.html",
        height: 386,
        args: { organizationId: organization.id },
      });
    },
  },
  {
    appKey: process.env.POWERUP_KEY,
    appName: process.env.POWERUP_NAME,
    appAuthor: "Native Power-Ups",
  }
);

const openModal = async (t) => {
  if (!(await checkAuthorizationAndSubscription(t))) {
    return; // Exit if the user is not authorized or subscribed
  }

  const context = t.getContext();
  const theme = context.initialTheme;
  const boardId = context.board;
  const background = await getBoardBackground(t, boardId);
  const adjustedTopColor = hexToAdjustedHex(
    background.topColor,
    background.brightness
  );

  return t.modal({
    title: process.env.POWERUP_NAME,
    url: "./modal.html",
    accentColor:
      theme === "dark" ? "#161A1D" : background ? adjustedTopColor : "",
    fullscreen: true,
  });
};

const powerupPermission = (t) => {
  const trelloContext = t.getContext();
  const memberCardPermission = trelloContext.permissions.card;
  if (memberCardPermission === "read") {
    return false;
  }
  return true;
};
